import type { SavedView } from 'app/services/savedViewsApi';

export type SaveViewModalMode =
  | null
  | { type: 'create' }
  | { type: 'edit'; view: SavedView };

type SaveViewModalBridge = {
  openCreate: () => void;
  openEdit: (view: SavedView) => void;
};

let bridge: SaveViewModalBridge | null = null;

export function registerSaveViewModalBridge(next: SaveViewModalBridge | null) {
  bridge = next;
}

export function openCreateSaveViewModal() {
  bridge?.openCreate();
}

export function openEditSaveViewModal(view: SavedView) {
  bridge?.openEdit(view);
}
